export default function Log({data}:any) {
    return(
        <div className="list-group me-0 pe-0 rounded-0">
            {data.map((value:any,index:number) => 
            <div className="list-group-item list-group-item-action" aria-current="true" key={index}>
                <div className="d-flex w-100 justify-content-between">
                    <h6 className="mb-1">{value.title}</h6>
                    <small>{value.date}</small>
                </div>
                {value.note && <p className="mb-1">{value.note}</p>}
            </div>
            )}
        </div>
    )
}